import { useRouter } from 'next/router';
import { useUrlModal } from '~/components/views/Onboarding/PlanPortfolio/modals/DepositSelectionModal/useUrlModal';
import { DepositTransferModalKey, UrlModalHelper, WalletGlobal } from '~/helpers/UrlModalHelper';
import { accountRoutes } from '~/routes/account';
import { formatCurrencyRoundedCents } from '~/utils/currencyFormatter';
import { Button, Heading, Modal, Text } from '~/vinovest-design-system/components';
import { IconWallet } from '~/vinovest-design-system/components/Icons';

export interface WalletGlobalModalProps {
    cashBalance: number;
    tradingCashBalance: number;
}

export const WalletGlobalModal: React.FC<WalletGlobalModalProps> = ({ cashBalance, tradingCashBalance }) => {
    const { open, closeModal } = useUrlModal(WalletGlobal);
    const router = useRouter();
    return (
        <Modal classnames={'max-w-[450px] w-11/12'} open={open} setOpen={closeModal} modalKey={WalletGlobal}>
            <div className={''}>
                <Heading
                    level={'h3'}
                    fontWeight={'font-normal'}
                    classnames={
                        'xs:!pt-2 sm:!pt-0 md:!pt-0 mb-4 mx-auto max-w-[530px] flex items-center justify-center gap-2 text-center text-transforn-none xs:!text-[24px] md:!text-[28px] !leading-snug'
                    }
                >
                    <IconWallet stroke={`#000`} width={'24px'} height={'24px'} /> Wallet
                </Heading>
                <Text classnames={'mb-2 mx-auto max-w-[500px] text-center text-[14px]'}>
                    <div className={'bg-gray-200 rounded-[20px] p-[15px]'}>
                        <p className={'font-vinovestmedium text-neutrals-900 font-normal text-16'}>Managed Cash</p>
                        <p className={'font-roslindale text-32 !font-light mt-[10px]'}>
                            {formatCurrencyRoundedCents(cashBalance)}
                        </p>
                        <div className={'my-2 text-14'}>Used for managed investments and fees.</div>
                    </div>
                </Text>
                <Text classnames={'mb-6 mx-auto max-w-[500px] text-center text-[14px]'}>
                    <div className={'bg-gray-200 rounded-[20px] p-[15px]'}>
                        <p className={'font-vinovestmedium text-neutrals-900 font-normal text-16'}>Trading Cash</p>
                        <p className={'font-roslindale text-32 !font-light mt-[10px]'}>
                            {formatCurrencyRoundedCents(tradingCashBalance)}
                        </p>
                        <div className={'my-2 text-14'}>Used to trade wine &amp; whiskey on the marketplace.</div>
                    </div>
                </Text>
                <div>
                    <Button
                        variant={'platinum'}
                        classnames={'w-full'}
                        onClick={() => {
                            closeModal();
                            UrlModalHelper.openModal(router, DepositTransferModalKey);
                        }}
                    >
                        Add Funds
                    </Button>
                </div>
                <div className={'mt-2'}>
                    <Button
                        variant={'secondary'}
                        disabled={cashBalance <= 0}
                        classnames={'w-full text-center'}
                        href={accountRoutes.withdrawalFunds.href}
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                            router.push(accountRoutes.withdrawalFunds.href);
                            // This is to ensure that the modal closes before navigating
                        }}
                    >
                        Withdraw Funds
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
